import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import Header from './Header';
import DesignModuleGrid from './DesignModuleGrid';

export default function Dashboard() {
  const { currentUser } = useAuth();
  
  // Extract user's name from email (before the @ symbol)
  const userName = currentUser?.email.split('@')[0] || 'Guest';
  // Capitalize first letter
  const formattedName = userName.charAt(0).toUpperCase() + userName.slice(1);

  return (
    <>
      <Header />
      <Container maxWidth="xl">
        <Box sx={{ py: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom fontWeight={700}>
            Welcome {formattedName}
          </Typography>
          <DesignModuleGrid />
        </Box>
      </Container>
    </>
  );
} 